module.exports = __webpack_public_path__ + "static/keith-rabois-313265f6c0b1bc4c8b3b4049d7e9b62e.jpg";